import { useQuery, useSubscription } from '@apollo/react-hooks';
import { useState, useEffect } from 'react';
import REPROCESS_CAMPAIGN_STATUS from '../../../../GraphQl/Queries/REPROCESS_CAMPAIGN_STATUS';
import REPROCESS_STATUS_SUBSCRIPTION from '../../../../GraphQl/Subscriptions/REPROCESS_STATUS_SUBSCRIPTION';

const PaidSearchReprocessHandler = (orgId) => {
  const [reprocessStatus, setReprocessStatus] = useState();
  const [reprocessData, setReprocessData] = useState();
  const reprocessKey = `paid-search-${orgId}`;


  // Initial query to get current status
  const { data, refetch } = useQuery(REPROCESS_CAMPAIGN_STATUS, {
    variables: {
      key: reprocessKey,
    },
    fetchPolicy: 'no-cache',
  });

  // Subscription for real-time updates
  const { data: subscriptionData } = useSubscription(REPROCESS_STATUS_SUBSCRIPTION, {
    variables: {
      where: {
        node: {
          key: reprocessKey,
        },
      },
    },
    skip: !orgId, // Skip subscription if orgId is not available
  });


  useEffect(() => {
    let isMounted = true;

    if (data && isMounted) {
      if (data.reprocessStatus) {
        setReprocessStatus(data.reprocessStatus.status);
        setReprocessData(data.reprocessStatus);
      } else {
        // No reprocess history exists for this paid search
        setReprocessStatus(null);
        setReprocessData(null);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [data]);

  useEffect(() => {
    let isMounted = true;

    if (subscriptionData && subscriptionData.reprocessStatus && subscriptionData.reprocessStatus.node && isMounted) {
      const { status } = subscriptionData.reprocessStatus.node;
      setReprocessStatus(status);
      setReprocessData(subscriptionData.reprocessStatus.node);
    }

    return () => {
      isMounted = false;
    };
  }, [subscriptionData]);


  return {
    reprocessStatus,
    reprocessData,
    refetchStatus: refetch,
  };
};

export default PaidSearchReprocessHandler;